import {EngagementId} from "platformed-client/types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";

export const engagementJoinLink = typedQuery(
  ["tprm", "engagementJoinLink", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.joinLinks.get(engagementId);
  },
);
